import React from "react";

/**
 * PixelButton
 * Retro blocky button with pixel-art border effect.
 *
 * Props:
 *   variant  — "primary" | "danger" | "ghost"  (default: "primary")
 *   size     — "sm" | "md" | "lg"              (default: "md")
 *   disabled — boolean
 *   onClick  — function
 *   type     — "button" | "submit" | "reset"   (default: "button")
 *   fullWidth — boolean
 *   children — React node
 */
const PixelButton = ({
  variant = "primary",
  size = "md",
  disabled = false,
  onClick,
  type = "button",
  fullWidth = false,
  children,
  className = "",
  ...rest
}) => {
  const base = "pixel-btn";
  const variantClass = `pixel-btn--${variant}`;
  const sizeClass = `pixel-btn--${size}`;
  const widthClass = fullWidth ? "pixel-btn--full" : "";

  return (
    <button
      type={type}
      className={`${base} ${variantClass} ${sizeClass} ${widthClass} ${className}`.trim()}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span className="pixel-btn__inner">{children}</span>
    </button>
  );
};

export default PixelButton;

/*
─── CSS to add in pixel.css ────────────────────────────────────────────


*/